var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page404 noPadding"},[_c('p',{staticClass:"page404_p0"},[_vm._v("Oooops! Sorry The Page Not Found :(")]),_c('router-link',{attrs:{"to":"/"}},[_c('a-button',[_vm._v("返回首页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }